export default __webpack_public_path__ + "static/media/metamask1.4b5d438a.png";